<template>
	<tbody @click="$emit('click', $event)" :class="{'can-hover': !noHover}">
		<tr>
			<slot :hidden="false"></slot>
			<td class="actions" v-if="removed.length > 0 || $slots.actions">
				<slot name="actions"></slot>
				<transition name="fade" mode="out-in">
					<icon-action @click="open = !open" v-if="removed.length > 0" :style="{transform: 'rotate(' + ((open)?'-90deg':'0deg') + ')'}">arrows/chevron/chevron-left-circle</icon-action>
				</transition>
			</td>
		</tr>
		<tr v-if="open && removed.length > 0">
			<td :colspan="total - removed.length">
				<table>
					<slot :hidden="true"></slot>
				</table>
			</td>
		</tr>
	</tbody>
</template>

<script>
	export default {
		props: ['noHover'],
		data() {
			return {
				open: false
			};
		},
		computed: {
			total() {
				return (this.$children || []).filter(x => x.$vnode.elm && x.$vnode.elm.nodeName === 'TD').length + 2;
			},
			removed() {
				return this.$parent.removed;
			}
		}
	}
</script>